<template>
  <div class="text-center">
    <v-dialog>
      <template #activator="{ props: activatorProps }">
        <v-hover>
          <template #default="{ isHovering, props: hoverProps }">
            <div v-bind="hoverProps" style="width:fit-content">
              <v-btn
                v-bind="activatorProps"
                density="comfortable"
                size="small"
                color="secondary"
                icon="mdi-pencil"
                variant="text"
                :style="{ 'background-color': isHovering ? '#e3f2fd' : '' }"
                :loading="uploadLoading"
                @click="showCropper=true"
              />
            </div>
          </template>
        </v-hover>
      </template>

      <template #default="{ isActive }">
        <CustomAvatarCropper
          v-if="showCropper"
          ref="avatarCropper"
          :labels="{
            submit: $t('Submit'),
            cancel: $t('Cancel')
          }"
          @submit="handleSubmit"
          @error="handleError"
          @cancel="isActive.value = false"
        />
      </template>
    </v-dialog>
  </div>
</template>

<script>
  import CustomAvatarCropper from '../parts/CustomAvatarCropper.vue'
  export default {
    components: { CustomAvatarCropper },
    props: {
      userId: {
        type: String,
        required: true
      }
    },
    emits: ['uploaded'],
    data: () => ({
      url: null,
      file: null,
      uploadLoading: false,
      showCropper: false
    }),
    methods: {
      handleSubmit () {
        this.uploadLoading = true
        let cropper = this.$refs.avatarCropper.cropper
        cropper.getCroppedCanvas().toBlob(
          blob => {
            let formData = new FormData()
            formData.append('file', blob)
            this.$http.put('user-avatar/' + this.userId + '/', formData, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then((res) => {
              setTimeout(() => {
                this.uploadLoading = false
                this.$emit('uploaded')
              }, 500)
            }, (error) => {
              this.uploadLoading = false
            })
          }
        )
      },
      handleError({ message, type, context }) {
        console.log('error: ', message, type, context)
      }
    }
  }
</script>

<style scoped>

</style>
